import api from '@/services/api.service';

// import { TokenService } from '@/services/storage.service';
// import { localStore } from '@/services/local.storage';
// import store from '@/store';

import { required, email} from 'vuelidate/lib/validators';

export default {
  name: 'forgot-password',
  components: {},
  props: [],
  data() {
    return {
        log: { email: '' },
        errors: '',
        submitStatus: null,
        loader: false
    };
},
  computed: {

  },
  validations: {
    log: {
        email: {
            required,email
        }
    }
  },
  mounted () {

  },
  methods: {
    makeToast(message = '', title = 'Alert', variant = 'warning') {
      this.toastCount++;
      this.$root.$bvToast.toast(message, {
          title: title,
          variant: variant,
          autoHideDelay: 3000
      });
    },
    async forgotPassword(event)
    {
        this.$v.$touch();
        if (this.$v.$invalid) {
            this.submitStatus = 'ERROR';
        } else{
          this.loader = true;
          this.msg = '';
          this.errors = '';
          let response = await api.post('/forgot-password', this.log);
         
          if (!response) this.makeToast('Something went to wrong please try again', 'Alert', 'danger', 6000);
          if (response.status == 'success') {
            this.loader = false;
            this.makeToast(response.message, 'Success', 'success', 6000);
            event.target.reset();
          } else {          
              this.makeToast(response.message, 'Alert', 'danger', 6000);
              this.loader = false;  
              event.target.reset();
        }

        } 
    }

  }
}


